import React from 'react';
import { PlayerControls, PlayerControlsContext } from '../player-controls/player-controls-context';

export const useControls = (): PlayerControls => {
  const values = React.useContext(PlayerControlsContext);

  return { ...values };
};

export default useControls;
